import {Spin, SpinProps} from 'antd';
import styles from './index.less';

interface Props {
    tip?: SpinProps['tip'];
}

export default ({tip}: Props) => (
    <div className={styles.suspenseFallback}><Spin tip={tip}><div className={styles.content} /></Spin></div>
);
